const communications = {
  communications: 'Comunicaciones',
  startCall: 'Iniciar llamada',
  sendMessage: 'Enviar mensaje',
  conversation:'Crear conversación',
  SMS: 'SMS',
  reminder: 'Recordatorio',
  call: 'Llamar',
  dashboardView: 'Vista del tablero',
  callPlanned: 'Llamada planificada',
  populateWaitingRoom: 'Poblar la sala de espera',
  start: 'Comienzo',
  communicationType: 'Tipo de comunicación',
  message: 'Mensaje',
  comment: 'Comentario',
  voiceMail: 'Mensaje de voz',
  sent: 'Enviado',
  mail: 'Correo',

  communicationsModal:{
    from:'Desde',
    to:'A',
    patient:'Paciente',
    messageCategory:'Categoría de mensaje',
    priority:'Prioridad',
    message:'Mensaje'
  }

}


export default communications
